import React from 'react';
import FaturasList from './FaturasList';

const FaturasGestao = () => <FaturasList pageMode="gestao" />;

export default FaturasGestao;
